module.exports = __webpack_public_path__ + "img/Icone-mes-infos-blanc.ad548a6e.svg";